import { createFileRoute } from '@tanstack/react-router';
import { DataOutConnectorRouteView } from '@/pages/workspaces/integrations/data-out/data-out-connector-route-view';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this connector.
 */
function DataOutConnectorRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <DataOutConnectorRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/data_out/$type')({
  component: DataOutConnectorRoute,
});
